
export default {
  name: 'PageGroup',
  async asyncData({ params, error, app }) {
    try {
      const group = await app.$axios.$get(`/api/eventgroup/${params.id}`)
      return {
        group
      }
    } catch (e) {
      return error({
        statusCode: 404
      })
    }
  },
  head() {
    const i18nSeo = this.$nuxtI18nSeo()
    // tiktokScript
    return {
      ...i18nSeo,
      title: `${this.group.name}`,
      meta: [
        ...i18nSeo.meta,
        this.group.description
          ? {
              hid: 'description',
              property: 'description',
              content: this.group.description
                .replace(/(<([^>]+)>)/gi, '')
                .replace(/\r?\n|\r/g, '')
                .slice(0, 500)
                .concat('...')
            }
          : {},
        { hid: 'og:type', property: 'og:type', content: 'website' },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${this.group.name}`
        },
        this.group.description
          ? {
              hid: 'og:description',
              property: 'og:description',
              content: this.group.description
                .replace(/(<([^>]+)>)/gi, '')
                .replace(/\r?\n|\r/g, '')
                .slice(0, 500)
                .concat('...')
            }
          : {},
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.imgBase}/1250x750.jpg`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${process.env.HOST}${this.localePath({
            name: 'groups-id',
            params: { eid: this.group.id }
          })}`
        }
      ]
    }
  },
  computed: {
    imgBase() {
      if (!this.group.image) {
        return null
      }

      return `${this.$config.CDN_URL}eventgroup/${this.group.id}/${this.group.image}`
    }
  }
}
